// extracted by mini-css-extract-plugin
module.exports = {"actions":"Actions_actions__8beHa","dot":"Actions_dot__1x6qQ"};